import React from "react";
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Toolbar, IconButton } from "@mui/material";
import { Dashboard, Menu, People, LibraryBooks, Route, Image, EmojiEvents, Payment, Subscriptions, Logout } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import { GiAchievement } from "react-icons/gi";

const Sidebar = ({ isMobile = false, toggleSidebar }) => {
    const location = useLocation(); // Get the current location
    const menuItems = [
        { text: "Dashboard", icon: <Dashboard />, path: "/account" },
        { text: "Users", icon: <People />, path: "users" },
        { text: "Members", icon: <People />, path: "members" },
        { text: "Guests", icon: <People />, path: "guests" },
        { text: "Instructors", icon: <People />, path: "instructors" },
        { text: "Bookings", icon: <LibraryBooks />, path: "bookings" },
        { text: "Plans", icon: <Route />, path: "plans" },
        { text: "Gallery", icon: <Image />, path: "gallery" },
        { text: "Challanges", icon: <EmojiEvents />, path: "challenges" },
        { text: "Achievements", icon: <GiAchievement size={25} />, path: "achievements" },
        { text: "Payments", icon: <Payment size={25} />, path: "payments" },
        { text: "Subcribers", icon: <Subscriptions size={25} />, path: "subscriptions" }
    ];

    const handleLogout = () => {
        localStorage.removeItem("gym_user");
        window.location.href = "/";
    };

    return (
        <Drawer variant={isMobile ? "temporary" : "permanent"} open onClose={toggleSidebar} sx={{ "& .MuiDrawer-paper": { width: 230, boxSizing: "border-box", backgroundColor: "#1E1E2F", color: "#FFFFFF" } }}>
            <Toolbar />
            {isMobile && (
                <IconButton onClick={toggleSidebar}>
                    <Menu />
                </IconButton>
            )}
            <List>
                {menuItems.map((item) => {
                    const isActive = location.pathname === `/account/${item.path}`;
                    return (
                        <ListItem button key={item.text} component={Link} to={item.path}
                            sx={{
                                backgroundColor: isActive ? "#3B82F6" : "transparent",
                                color: isActive ? "#FFFFFF" : "#A4A4A4",
                                "&:hover": {
                                    backgroundColor: "#3B82F6",
                                    color: "#FFFFFF"
                                }
                            }}
                        >
                            <ListItemIcon sx={{ color: isActive ? "#FFFFFF" : "#A4A4A4" }}>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItem>
                    );
                })}
                <div className="w-[90%] mx-auto mt-4 rounded-lg" onClick={handleLogout}>
                    <ListItem button className="bg-red-700 hover:bg-red-600 cursor-pointer text-white">
                        <ListItemIcon sx={{ color: "#FFFFFF" }}>
                            <Logout />
                        </ListItemIcon>
                        <ListItemText primary="Logout" />
                    </ListItem>
                </div>
            </List>
        </Drawer>
    );
};

export default Sidebar;
